let historyCaptureEnabled = false;

export const isHistoryEnabled = (): boolean => historyCaptureEnabled;
export const enableHistory = (): void => { historyCaptureEnabled = true; };
export const disableHistory = (): void => { historyCaptureEnabled = false; };

const historyToggle = { isHistoryEnabled, enableHistory, disableHistory };
export default historyToggle;


